import React from "react";
import { Link } from "react-router-dom";

const EducationAccordianContent: React.FC = () => {
    return (
        <>
            <p>
                You are now good to go! You can start using Rend A Hand to
                render your jobs. There are two main functions you should know.
            </p>
            <p>
                1) Stop Processing Jobs: Will finish the current job and then
                stop processing new jobs.
            </p>
            <p>
                2) Create Job: Using this, you can upload a .blend file to be
                rendered.
            </p>
            <hr />
            <p>
                Optional: You can download our addon to access Rend A Hand
                within Blender. Learn more <Link to="/addon">here</Link>.
            </p>
        </>
    );
};

export default EducationAccordianContent;
